import type { LoaderFunction, LoaderFunctionArgs } from 'react-router-dom';
import { apiGetBeltByIdTag } from "../components/ui_components/ApiList";

export const TagBeltHallOfFameLoader: LoaderFunction = async ({ params }: LoaderFunctionArgs) => {
    try {
        const idParam = params.id;
        if (!idParam) {
            throw new Error('Belt ID is required');
        }
        const id = parseInt(idParam, 10);
        if (isNaN(id)) {
            throw new Error('Invalid Belt ID');
        }
        const response = await apiGetBeltByIdTag(id);
        return response;
    } catch (error) {
        throw new Error('Failed to load belt data');
    }
};
